"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetEmployeesDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const constants_1 = require("../../../../../service-lib/src/lib/constants");
const swagger_1 = require("@nestjs/swagger");
class GetEmployeesDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
    }
}
exports.GetEmployeesDto = GetEmployeesDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Field to sort by",
        example: "id",
        required: false,
    }),
    tslib_1.__metadata("design:type", String)
], GetEmployeesDto.prototype, "sort", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, swagger_1.ApiProperty)({
        description: "Search term for filtering",
        example: "Test",
        required: false,
    }),
    tslib_1.__metadata("design:type", String)
], GetEmployeesDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Field to search by (e.g., contactName, companyName, phone, status).",
        example: "companyName",
    }),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", String)
], GetEmployeesDto.prototype, "searchBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({ allowNaN: false, allowInfinity: false }),
    tslib_1.__metadata("design:type", Number)
], GetEmployeesDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({ allowNaN: false, allowInfinity: false }),
    tslib_1.__metadata("design:type", Number)
], GetEmployeesDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Number),
    (0, class_validator_1.IsNumber)({ allowNaN: false, allowInfinity: false }),
    tslib_1.__metadata("design:type", Number)
], GetEmployeesDto.prototype, "employeeId", void 0);
